import { APP_PERMISSIONS } from '@report/permission';
import {
  QSetUsageReportList,
  QSetUsageReportFilterSection,
  QSetUsageReportPageHeader,
  QSetUsageReportExportButton,
} from '@report/qset-usage-report';
import { Flex, PaperSection } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function QSetUsageReportPage() {
  return (
    <PermissionGuard requiredPermission={[APP_PERMISSIONS.QSET_USAGE_STATUS_REPORT.VIEW]}>
      <Flex sx={{ flexDirection: 'column', minHeight: '100dvh' }}>
        <QSetUsageReportPageHeader />
        <Flex sx={(theme) => ({ p: theme.spacing(6), flexGrow: 1 })}>
          <PaperSection
            title='รายงานสถานะการใช้งานชุดข้อสอบ'
            endAdornment={<QSetUsageReportExportButton />}
          >
            <Flex
              sx={(theme) => ({
                p: theme.spacing(6),
                gap: theme.spacing(6),
                flexGrow: 1,
                flexDirection: 'column',
              })}
            >
              <QSetUsageReportFilterSection />
              <QSetUsageReportList />
            </Flex>
          </PaperSection>
        </Flex>
      </Flex>
    </PermissionGuard>
  );
}
